module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/murin7-c0c1b1dd04848b0000ccb23b17c36b45.jpg";